import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { USER_MGMT_CNST } from '../../../constants/proj.cnst';
import { AppStateService } from '../../../services/app-state.service';
import { UtilsService } from '../../../services/utils.service';
import { HttpService } from '../../../services/http.service';
import { EnvService } from '../../../services/env.service';
@Component({
  selector: 'app-required-actions',
  templateUrl: './required-actions.component.html',
  styleUrls: ['./required-actions.component.scss']
})
export class RequiredActionsComponent {

  forgotPasswordForm: FormGroup;
  submitted: boolean = false;
  displayErrorMessage: string = "";
  activespiner: boolean = true;
  forgotPasswordConfig : any = {};
  diVisible:boolean = false;
  userName:any;
  updatePassword:boolean = false;
  verifyEmail:boolean = false;
  userId:any;
  hide : boolean = true;
  constructor(
    private fb: FormBuilder,
    private appState: AppStateService,
    private authSrv: AuthenticationService,
    private cmnSrv : CommonService,
    private router: Router,
    private utilsServ: UtilsService,
    private httpSrv: HttpService,
    private envService : EnvService,
    private route: ActivatedRoute
    ) {
    this.forgotPasswordForm = fb.group({
      'password': ['', [Validators.required,Validators.minLength(11),this.passwordValidator]],
    })
  }

  ngOnInit() {
    this.subscribeRouterEvents()
    this.getActions();
  }
  subscribeRouterEvents(){
    this.route.queryParams.subscribe((params: any) => {
      this.userName = params?.username
    })
  }
  getActions(){
    this.httpSrv.makeGetApiCall('GET_ACTIONS_BY_USERNAME',this.envService.baseUrl,{
      replaceParams: {
        REPLACE_USERNAME: this.userName,
      }}).subscribe({
      next: (response: any) => {
        if(response?.statusCode == 404){
          this.utilsServ.showToastMessage("User Not Found in Database", "error");
        }else{
           this.userId = response?.message;
          if(response?.response?.length == 0){
            this.logout()
          }
          else if(response?.response?.length > 0 && response?.response.includes("UPDATE_PASSWORD")){
           this.updatePassword = true;
          }else{
            if(response?.response?.length > 0 && response?.response.includes("VERIFY_EMAIL")){
              this.verifyEmail = true;
             }
          }
        }
      },
      complete: () => {},
      error: (err: any) => {
        this.utilsServ.showToastMessage("Error in GET_ACTIONS_BY_USERNAME", "error");
      }
    });
  }
  get formControl() {
    return this.forgotPasswordForm.controls;
  }

  logout() {
    this.authSrv.setUserInfo(null, ("null" as string));
    this.appState.setPermissionsLoaded(false);
    this.appState.setInProcess(false);
    this.appState.setUserMetaInfo({});
    this.appState.setUserPermissionsRef({});
    this.router.navigate(USER_MGMT_CNST.COMMON_ROUTE_MAPPING.LOGIN);
  }
  onsubmit(){
   this.updatePasswordAndRemoveAction();
  }

  updatePasswordAndRemoveAction(){
      let postData = {
        "type": "password",
        "value": this.forgotPasswordForm.getRawValue()?.password,
        "userId": this.userId,
        "temporary": false,
        "removeAction":true
      }

      this.httpSrv.makePutApiCall('KEYCLOAK_RESET_PASSWORD', postData, this.envService.baseUrl).subscribe({
        next: (response: any) => {
          let { result } = response;
          this.utilsServ.showToastMessage("Password updated successfully", "success");
            if (result) {
              this.logout();
            }
        },
        complete: () => {},
        error: (err: any) => {
          this.utilsServ.showToastMessage("Error in updating password", "error");
        }
      });
  }

  notAllowSpace(event: any) {
    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
    }
  }
  
  passwordValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{11,50}$/;
    if (control.value && !passwordPattern.test(control.value)) {
      return { 'invalidPassword': true };
    }
    return null;
  }
}
